module.exports = __webpack_public_path__ + "public/img/luntan.9b3ec1e8.png";